<template>
    <el-dialog :visible="openDialog"
               :close-on-click-modal="false"
               :close-on-press-escape="!processing"
               :show-close="!processing"
               @close="$emit('update:openDialog', false)"
               :title="(eraseModeOn ? 'Remove' : 'Add') + ' Multiple Cities'">

        <el-form :model="formData">
            <el-form-item label="Radius in miles">
                <el-input-number v-model="formData.radius"
                                 :disabled="processing"
                                 :step="1"
                                 :min="0"
                                 style="width:100%"/>
            </el-form-item>
            <el-form-item label="Cities or States (one on a line)">
                <el-input type="textarea"
                          :disabled="processing"
                          :rows="6"
                          v-model="formData.data"/>
            </el-form-item>

        </el-form>

        <el-alert v-if="errorMessage !== null" title="Error: " type="error" :closable="false">
            {{ errorMessage }}
        </el-alert>

        <span slot="footer" class="dialog-footer">
            <el-button :disabled="processing" @click="$emit('update:openDialog', false)">Cancel</el-button>
            <el-button :disabled="processing" :type="eraseModeOn ? 'danger' : 'success'" @click="process">
                <i v-if="processing" class="fa fa-pulse fa-spinner"></i> {{ eraseModeOn ? 'Remove' : 'Add' }}
            </el-button>
        </span>

    </el-dialog>
</template>

<script>
    export default {
        props: {
            areaId: { type: Number, required: true },
            openDialog: { type: Boolean, required: true },
            eraseModeOn: { type: Boolean, required: true },
            mapUrl: { type: Function, required: true }
        },
        data() {
            return {
                formData: {
                    data: '',
                    radius: '35',
                },
                processing: false,
                errorMessage: null,
            };
        },
        methods: {
            process() {
                this.processing = true;
                this.errorMessage = null;

                axios.post(this.url(`admin/area/add-multiple-cities`),
                    _.merge(this.formData, { area_id: this.areaId, is_exclusion: this.eraseModeOn }))
                    .then(response => {
                        if (typeof response.data.errors !== 'undefined' && response.data.errors !== null) {
                            this.errorMessage = response.data.errors;
                        } else {
                            this.$set(this.formData, 'data', '');
                            this.$set(this.formData, 'radius', '35');
                            this.$emit('process');
                            this.$emit('update:openDialog', false);
                        }
                    })
                    .catch(err => {
                        this.errorMessage = `Ooops, operation could not be performed due to: ${err.message}`;
                    })
                    .finally(() => { this.processing = false; });
            },
        },
    };
</script>
